import { ApolloError, useQuery } from '@apollo/client';
import { GET_IT_APPLICATION_METRICS } from '../graphql';
import { CyberHubItApplicationMetricsData } from '../types/it-applications';

type ItApplicationMetricsParams = {
  includeUnmapped?: boolean;
};

type ItApplicationMetricsResult = {
  data: CyberHubItApplicationMetricsData[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
};

/**
 * Hook to fetch IT applications
 *
 * @param locationUUID - The UUID of the location to fetch applications for.
 * @param includeUnmapped - Whether to include unmapped applications.
 * @returns
 */
export const useItApplicationMetrics = (
  locationUUID?: string,
  { includeUnmapped = false }: ItApplicationMetricsParams = {},
): ItApplicationMetricsResult => {
  const result = useQuery(GET_IT_APPLICATION_METRICS, {
    variables: { locationUUID, includeUnmapped },
  });

  if (result.error) {
    console.error('useItApplications GraphQL error:', result.error);
  }

  return {
    data: result.data?.getItApplicationMetrics,
    loading: result.loading,
    error: result.error,
  };
};
